import { Env } from '#modules/env';

const { hostname } = location;
export const MenuItemId = {
  ...(hostname.startsWith('local-example') ? { _EXAMPLE: '_EXAMPLE' } : {}),
  PERSONAL_INFO: 'PERSONAL_INFO',
  SECURITY: 'SECURITY',
  NOTIFY: 'NOTIFY',
  BOARD: 'BOARD',
  MESSAGE: 'MESSAGE',
  MAIL: 'MAIL',
  CALENDAR: 'CALENDAR',
  CONTACT: 'CONTACT',
  DRIVE: 'DRIVE',
  TASK: 'TASK',
  FORM: 'FORM',
  CLOVANOTE: 'CLOVANOTE',
};

export const MenuItemURL = {
  ...(MenuItemId._EXAMPLE ? { [MenuItemId._EXAMPLE]: '/settings' } : {}),
  [MenuItemId.PERSONAL_INFO]: `${Env.ServiceURL.CONTACT}/personal-info-settings`,
  [MenuItemId.SECURITY]: `${Env.ServiceURL.COMMON}/security-settings`,
  [MenuItemId.NOTIFY]: `${Env.ServiceURL.NOTIFY}/settings`,
  [MenuItemId.BOARD]: `${Env.ServiceURL.BOARD}/settings`,
  [MenuItemId.MESSAGE]: `${Env.ServiceURL.TALK}/settings`,
  [MenuItemId.MAIL]: `${Env.ServiceURL.MAIL}/settings`,
  [MenuItemId.CALENDAR]: `${Env.ServiceURL.CALENDAR}/settings`,
  [MenuItemId.CONTACT]: `${Env.ServiceURL.CONTACT}/settings`,
  [MenuItemId.DRIVE]: `${Env.ServiceURL.DRIVE}/settings`,
  [MenuItemId.TASK]: `${Env.ServiceURL.TASK}/settings`,
  [MenuItemId.FORM]: `${Env.ServiceURL.FORM}/settings`,
  [MenuItemId.CLOVANOTE]: `${Env.ServiceURL.CLOVANOTE}/settings`,
};
